module.exports = __webpack_public_path__ + "static/img/tb_rzs.cf46c30.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/tb_rzs.png
// module id = zqeP
// module chunks = 0